export enum ETierRankingPolicyStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export type TTierRankingPolicy = {
  id: string
  year: number
  status: ETierRankingPolicyStatus
  gracePeriodMonths: number
  consecutiveMonthsToPromote: number
  areaGroupIds: number[] | null
  thresholds: TTierThreshold[]
  publishedAt: string | null
  publishedBy: string | null
  createdAt: string
  updatedAt: string
}

export type TUpdateTierRankingPolicy = {
  gracePeriodMonths?: number
  consecutiveMonthsToPromote?: number
  areaGroupIds?: number[] | null
  thresholds?: TTierThresholdInput[]
}

export enum EDealerTierKey {
  MEMBER = 'MEMBER',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
}

export type TTierThresholdInput = {
  tierId: number
  minRevenue: number
  minArea: number
}

export type TTierThreshold = TTierThresholdInput & {
  tierKey: EDealerTierKey
  displayName: string
  sortOrder: number
}

export type TDealerTier = {
  id: number
  tierKey: EDealerTierKey
  displayName: string
  minRevenue: number
  minArea: number
  sortOrder: number
  brandColor: string | null
}

export type TUpdateDealerTier = {
  displayName?: string
  brandColor?: string
}
